window.components.faq = {
    selector: "section[faq]",

    init: function () {
        this.events();
    },

    events: function () {
        $(this.selector)
            .find(".questions-items")
            .on("click", ".questions-item", this.onClickOpenQuestions);
    },

    onClickOpenQuestions: function (e) {
        e.preventDefault();
        $(this).toggleClass("active");
    },
};
